import axios from 'axios';
import { bdmAppOrigin } from '../config/sfApiBase';

function getOnboardingApiBase() {
  if (process.env.NODE_ENV === 'development') {
    return '/api/onboarding';
  }
  return `${bdmAppOrigin()}/api/onboarding`;
}

/** WordPress property posts: current FY YTD vs same period last FY (Jul 1 – Jun 30). */
export async function fetchWpPropertyPostsFy() {
  const res = await axios.get(`${getOnboardingApiBase()}/wp-property-posts-fy`);
  return res.data;
}
